export interface StatEntry {
  type: 'reputation' | 'capital' | 'credit';
  delta: number;
  reason: string;
  ts: string;
}

const KEY = 'kap_stat_history';
const MAX = 30;

export function logStatChange(type: StatEntry['type'], delta: number, reason: string): void {
  try {
    const raw = localStorage.getItem(KEY);
    const prev: StatEntry[] = raw ? JSON.parse(raw) : [];
    const next = [{ type, delta, reason, ts: new Date().toISOString() }, ...prev].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch { /* ignore */ }
}

export function getStatHistory(): StatEntry[] {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch { return []; }
}
